module.exports = __webpack_public_path__ + "img/class-icono.1cba92ae.svg";